import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  click(event) {
    if (!this.urlValue) return;
    if (this.isInteractiveTarget(event.target)) return;
    event.preventDefault();
    if (window.Turbo && typeof window.Turbo.visit === "function") {
      window.Turbo.visit(this.urlValue);
    } else {
      window.location = this.urlValue;
    }
  }

  isInteractiveTarget(element) {
    const node = element.closest("a, button, [data-no-row-nav]");
    return node !== null;
  }
}
